import { useEffect, useState } from 'react';

const getThemeFromLocalStorage = () => {
  if (window.localStorage.getItem('dark')) {
    return JSON.parse(window.localStorage.getItem('dark'));
  }

  // else return their preferences
  return (
    !!window.matchMedia &&
    window.matchMedia('(prefers-color-scheme: dark)').matches
  );
};

const useToggleTheme = () => {
  const [isDarkMode, setDarkMode] = useState(false);

  useEffect(() => {
    const result = getThemeFromLocalStorage();
    setDarkMode(result);

    const togglerEl = document.querySelector('.theme-toggler');
    togglerEl?.addEventListener('click', () => {
      setTimeout(() => {
        const result = getThemeFromLocalStorage();
        setDarkMode(result);
      }, 50);
    });
  }, []);

  return {
    isDarkMode,
    setDarkMode,
  };
};

export default useToggleTheme;
